import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-bank-transaction-excel4',
  templateUrl: './bank-transaction-excel4.component.html',
  styleUrls: ['./bank-transaction-excel4.component.scss']
})
export class BankTransactionExcel4Component implements OnInit {

  document_file: any = null;
  from_date: any;
  to_date: any;
  is_document_available: boolean = true;

  bank_data_list: any;

  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  customer_type_list:any;
  selected_customer_type: any;

  constructor(private httpService: HttpService, private global: GlobalService) { 
    this.title = this.global._active_display_name;
    this.httpService.serveCustomerTypes().subscribe((data)=>{
      this.customer_type_list = data['customer_type_list'];
    }, (error) => {
      console.log(error);
    })
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'customer_type': this.selected_customer_type
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.document_file = null;
    this.httpService.bankTransactionExcel4(data_dict).subscribe((data) => {
      console.log(data);
      this.bank_data_list = data['bank_data_list']
      this.document_file = data;
      this.is_document_available = true;
      
    }, (error) => {
      this.is_document_available = true;
    });
  }

  changeEvent() {
    this.document_file = null;
  }

  downloadClicked() {
    const linkSource = 'data:application/excel;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  ngOnInit() {
  }

}
